import { login, logout } from "@/services/auth";
import parseJwt from "@/util/parseJwt";
import { setCookie, delCookie, getCookie } from "@/util/cookies";


const auth = {
  namespaced: true,
  state: () => ({
    dataLoginSuccess: "",
    dataLoginFailed: "",
    isLoading: false,
    role: "",
    currentUser: "",
  }),
  getters: {
    SUPERADMIN(state) {
      return state.dataLoginSuccess.data.roleId === 1;
    },
    MANAGER(state) {
      return state.dataLoginSuccess.data.roleId === 2;
    },
    MEMBER(state) {
      return state.dataLoginSuccess.data.roleId === 3;
    },
    TEAMLEADER(state) {
      return state.dataLoginSuccess.data.roleId === 4;
    },
    INTERNSHIP(state) {
      return state.dataLoginSuccess.data.roleId === 5;
    },
  },
  mutations: {
    setDataSuccess(state, response) {
      state.dataLoginSuccess = response;
      setCookie('token', response.data.token, process.env.NODE_ENV)
      state.isLoading = false;
    },
    setDataFailed(state, error) {
      state.isLoading = false;
      state.dataLoginFailed = error;
    },
    setLoading(state, payload) {
      state.isLoading = payload;
    },
    setRole(state) {
      const token = getCookie("token");
      if (token) {
        const { role } = parseJwt(token);
        const { userId } = parseJwt(token);
        state.role = role;
        state.currentUser = userId;
      }
    },
  },
  actions: {
    async callLogin(store, request) {
      try {
        store.commit("setLoading", true);
        const res = await login(request);
        store.commit("setDataSuccess", res.data);
        return res.data;
      } catch (err) {
        store.commit("setDataFailed", err.response.data.error);
      }
    },
    async callLogout(store) {
      try {
        const res = await logout();
        delCookie('token')
        return res;
      } catch (err) {
        console.log(err)
        throw err;
      }
    },
  },
};

export default auth;
